import {MapState, Spawn} from 'src/common/map/MapState';
import {BuildabilityComponent} from '../components/BuildabilityComponent';
import {Location} from 'src/common/map/Location';
import {Service} from './Service';
import {Game} from 'src/game/Game';
import {buildabilityRenderer} from 'src/Pixi/map/BuildabilityRenderer';

export class BuildabilityService implements Service {
    public constructor(public game: Game) {
        // Sets instance properties
    }

    public tick(): void {
        switch (this.game.stateName) {
            case 'build':
                if (this.shouldUpdateBuildability()) {
                    this.updateBuildability();
                    buildabilityRenderer.needsRerender = true;
                }
                break;

            case 'place':
                this.updatePrevHeldBy();
                break;

            default:
                break;
        }
    }

    public lateTick(): void {
        this.buildability.lastHeldBy = this.map.spawns.map(({x, y}) => this.map.heldBy[y][x]);
    }

    private shouldUpdateBuildability(): boolean {
        return this.haveNotSetBuildabilityBefore() || this.haveAnySpawnsChanged();
    }

    private haveNotSetBuildabilityBefore(): boolean {
        return this.buildability.minDistanceGrids
            ? this.buildability.minDistanceGrids.length === 0
            : false;
    }

    private haveAnySpawnsChanged(): boolean {
        return this.map.spawns.some((_spawn, index) => this.spawnHeldByChanged(index));
    }

    private updateBuildability(): void {
        const grids = [];
        const isSource = (spawn: Spawn, playerIndex: number): boolean =>
            this.spawnPrevHeldBy(spawn, playerIndex) || this.spawnIsHeldBy(spawn, playerIndex);
        for (let playerIndex = 0; playerIndex < this.map.playerCount; playerIndex++) {
            const sources = this.map.spawns
                .filter(spawn => isSource(spawn, playerIndex))
                .map(spawn => Location.fromLoc(spawn));
            grids.push(this.map.distanceGrid(sources));
        }
        this.buildability.minDistanceGrids = grids;
    }

    private spawnIsHeldBy(spawn: Spawn, playerIndex: number): boolean {
        return this.map.heldBy[spawn.y][spawn.x] === playerIndex;
    }

    private spawnPrevHeldBy(spawn: Spawn, playerIndex: number): boolean {
        return spawn.prevHeldBy === playerIndex;
    }

    private spawnHeldByChanged(index: number): boolean {
        const spawn = this.map.spawns[index];
        return this.map.heldBy[spawn.y][spawn.x] !== this.buildability.lastHeldBy[index];
    }

    private updatePrevHeldBy(): void {
        for (let playerIndex = 0; playerIndex < this.map.playerCount; playerIndex++) {
            this.map.heldSpawns(playerIndex).forEach(spawn => {
                spawn.prevHeldBy = playerIndex;
            });
        }
        this.updateBuildability();
    }

    private get map(): MapState {
        return this.game.map;
    }

    private get buildability(): BuildabilityComponent {
        return this.game.buildability;
    }
}



// WEBPACK FOOTER //
// ./src/common/services/BuildabilityService.ts